import { Component } from '@angular/core'
import { AjaxService } from './shared/ajax.service'
import { GlobService } from './shared/glob.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  constructor(private ajax: AjaxService, private glob: GlobService) {
    this.conf()
  }

  async conf() {
    await this.ajax.execute({
      url: 'config/info',
      success: (post) => {
        let theme = this.glob.config.theme
        post.result.theme = post.result.theme || 'base'
        this.glob.config = post.result.config
        this.glob.themes = post.result.themes
        
        if(this.glob.config.theme!=theme) this.glob.themer(this.glob.config.theme)
        $('title').html(this.glob.config.tit)
      }
    })
  }
}
